import {Component, Input, OnInit} from '@angular/core';
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {Website} from "../../../website";
import * as fromStore from "../../../../../store";
import {combineLatest, Subject} from "rxjs";
import {Store} from "@ngrx/store";
import {FormControl} from "@angular/forms";
import {TaxRate} from "./mapper/tax-rate";
import {IDsDropdownOption} from "../../../../../shared/components/ds-dropdown/ds-dropdown-option";
import {AddTaxRateComponent} from "../add-tax-rate/add-tax-rate.component";
import {DbModalService} from "../../../../../modules/modal/modal";

@Component({
    selector: 'db-ecommerce-tax-rate-table',
    templateUrl: './tax-rate-table.component.html',
    styleUrls: ['./tax-rate-table.component.scss'],
    standalone: false
})
export class EcommerceTaxRateTableComponent implements OnInit {
  @Input() website: Website;
  public searchTerm: FormControl = new FormControl("");
  public currentPage: number = 1;
  public itemsPerPage: number = 20;
  public loadingBtn: boolean;
  public resetFilter: boolean;
  private readonly _destroyStream$ = new Subject<boolean>();
  public addRatesOptions: IDsDropdownOption[];
  public addRatesOptionsFilter: IDsDropdownOption[];
  public heads: string[] = [
    TextUtils.getText('text_countryCode'),
    TextUtils.getText('text_stateCode'),
    TextUtils.getText('text_postcodeZip'),
    TextUtils.getText('text_city'),
    TextUtils.getText('text_rate'),
    TextUtils.getText('text_taxName'),
    TextUtils.getText('text_priority'),
    TextUtils.getText('text_compound'),
    TextUtils.getText('text_shipping')
  ];
  public taxRatesList: TaxRate[];
  public filteredTaxRatesList: TaxRate[];
  public isScrollingHorizontal = false;
  public enabled: boolean;
  public loading: boolean;

  constructor(
    private readonly _store: Store<fromStore.DbStoreState>,
    private _modalService: DbModalService
  ) { }

  ngOnInit() {
    this._getTaxRatesList();
    this._listenSearch();
    this._getTaxClasses();
  }

  private _getTaxRatesList(): void {
    this._store.select(fromStore.getEcommerceTaxRatesLoaded(this.website?.id))
        .pipe(
            filter((loaded: boolean) => loaded),
            switchMap(() => combineLatest(
                this._store.select(fromStore.getEcommerceTaxRates(this.website?.id)),
                this._store.select(fromStore.getEcommerceTaxShippingClass(this.website?.id))
            )),
            takeUntil(this._destroyStream$)
        )
        .subscribe(([taxRates, taxSettings]) => {
          this.taxRatesList = taxRates;
          this.filteredTaxRatesList = taxRates;
        });
  }

  private _getTaxClasses(): void {
    this._store.select(fromStore.getEcommerceTaxClassesLoaded(this.website?.id))
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getEcommerceTaxClasses(this.website?.id)),
          this._store.select(fromStore.getEcommerceTaxClassesFilter(this.website?.id))
        )),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([taxClasses, taxClassesFilter]) => {
        this.addRatesOptionsFilter = taxClassesFilter;
        this.addRatesOptions = taxClasses;
      });
  }

  public filterByClass(value): void {
    this.resetFilter = value === '';
    this.filteredTaxRatesList = this.taxRatesList.filter(item => item?.class.includes(value));
  }

  public editTaxRate(taxRate: TaxRate) {
    const modal = this._modalService.open(AddTaxRateComponent, {width: 700});
    modal.componentInstance.website = this.website;
    modal.componentInstance.taxRate = taxRate;
  }

  public addTaxRate(taxRateClass: any) {
    const modal = this._modalService.open(AddTaxRateComponent, {width: 700});
    modal.componentInstance.website = this.website;
    modal.componentInstance.taxRateClass = taxRateClass;
  }

  public clearFilter(): void {
    this.loadingBtn = true;
    this.filterByClass('');
    setTimeout(() => {
      this.loadingBtn = false
    }, 800);
  }

  private _setFilteredData(taxRates, value): void {
    this.filteredTaxRatesList = taxRates.filter(item => Object.values(item).some(el => typeof el === 'string' && el.includes(value)));
  }

  public onScroll(event: any) {
    this.isScrollingHorizontal = event.target.scrollLeft > 0;
  }

  private _listenSearch() {
    this.searchTerm.valueChanges
        .pipe(
            takeUntil(this._destroyStream$)
        )
        .subscribe(value => {
          this._setFilteredData(this.taxRatesList, value);
        });
  }

}
